/*
 * Copyright (C) Fraunhofer IESE 2021-2024 - Pedram (Majid) Jokar, Mher Ter-Tovmasyan,
 * Bestin John, Steffen Hupp, Anna Kleiner, Rafael Aranda Lopez King, Emily Calvet, Philipp Ewen,
 * Matthias Gerbershagen, Milad Chatrangoon, Stefan Schweitzer
 *
 * SPDX-License-Identifier: AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <https://www.gnu.org/licenses/>.
 */

import { defaultOrganizationLogo, defaultPersonLogo } from 'assets';

// Default images
export const DEFAULT_ORGANIZATION_IMAGE_PATH = defaultOrganizationLogo;
export const DEFAULT_PROFILE_IMAGE_PATH = defaultPersonLogo;

// Pagination
export const SIZE_PER_PAGE = 10;

// Allowed roles
export const ALLOWED_ROLES = ['admin', 'member'];

// Mobile view
export const MOBILE_VIEW_WIDTH = 768;

export * from './auth';
export * from './encryption';
export * from './features';
export * from './form';
export * from './param';
export * from './query';
export * from './reference';
export * from './route';
export * from './service';
export * from './serviceError';
export * from './slr-library';
export * from './toast';
